import React from 'react';
import { ClockIcon, HelpCircleIcon, LayersIcon, RouteIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { problems } from '../data/content';
const ICONS = {
  layers: LayersIcon,
  question: HelpCircleIcon,
  route: RouteIcon,
  clock: ClockIcon
};
export function ProblemSection() {
  return <section aria-labelledby="problema" className="border-b border-line bg-canvasAlt" data-id="element-133" data-mp="2vppl32fc7wa4">
      <div className="mx-auto max-w-2xl px-3 py-6 text-center sm:px-5" data-id="element-134" data-mp="39gb4qtcm8a92">
        <p className="font-display text-[0.62rem] font-bold uppercase tracking-[0.16em] text-accent" data-id="element-135" data-mp="35h2a7m9r48cg">
          ¿Te suena familiar?
        </p>
        <h2 id="problema" className="mt-1.5 font-display text-base font-extrabold leading-tight text-ink sm:text-xl" data-id="element-136" data-mp="3jdzd4m359g9p">
          Quieres aprender a instalar cerraduras inteligentes y sistemas de
          control de acceso, pero no sabes por dónde empezar.
        </h2>
        <p className="mx-auto mt-1.5 max-w-xl text-[0.8rem] leading-snug text-ink-muted" data-id="element-137" data-mp="1k4slqjjosgck">
          Si estás comenzando desde cero o quieres agregar este servicio a lo
          que ya haces, probablemente conozcas alguna de estas situaciones:
        </p>

        <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-138" data-mp="sdjllhxwqqow">
          {problems.map((problem, i) => {
          const Icon = ICONS[problem.icon];
          return <Reveal key={problem.title} as="li" delay={i * 0.03} className="flex h-full gap-2.5 rounded-lg border border-line bg-surface p-3 text-left" data-id="element-139" data-mp="123lcsilk4p81" data-mpi={i}>
                <span className="flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-md bg-danger-soft" data-id="element-140" data-mp="1c2u391h7rlpn">
                  <Icon size={15} className="text-danger" data-id="element-141" data-mp="1g2ugiisktqv4" />
                </span>
                <div data-id="element-142" data-mp="3du75firsrfi0">
                  <h3 className="font-display text-[0.8rem] font-extrabold uppercase leading-tight text-ink" data-id="element-143" data-mp="3duqgqgmxz5n2">
                    {problem.title}
                  </h3>
                  <p className="mt-1 text-[0.78rem] leading-snug text-ink-muted" data-id="element-144" data-mp="ozh78lotvkqw">
                    {problem.desc}
                  </p>
                </div>
              </Reveal>;
        })}
        </ul>
      </div>
    </section>;
}